<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="佣金任务名称" prop="name" >
        <a-input v-model="form.name" placeholder="请输入" />
      </a-form-model-item>
      <a-form-model-item label="上传本地文件" prop="fileUrl" >
        <p style="margin-top: -40px;padding-left: 120px;font-size: 10px">
          为确保上传内容与列表内容匹配，请先
          <a href="https://admin.trhr.com.cn/%E4%BD%A3%E9%87%91%E4%B8%8B%E5%8F%91%E6%A8%A1%E7%89%88.xls" >下载实例文件</a>
<!--          <a href="" @click="importTemplate">下载实例文件</a>-->
        </p>
        <a-spin tip="上传中..." :spinning="uploading">
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :file-list="fileList"
            :multiple="false"
            :remove="handleRemove"
            :before-upload="beforeUpload"
          >
            <p class="ant-upload-hint">
              点击上传
            </p>
          </a-upload-dragger>
        </a-spin>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-textarea :row="4" v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getBrokerage, addBrokerage, updateBrokerage } from '@/api/user/brokerage'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      uploading: false,
      submitLoading: false,
      formTitle: '',
      fileList: [],
      // 表单参数
      form: {
        id: null,

        name: null,

        fileUrl: null,

        sendNum: null,

        status: 0,

        cateName: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        cateName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    /**
     * 文件上传前校验
     * @param {config.form.item} formItem 表单项
     * @param {*} fileInfo 文件详情, 见 a-upload 组件 customRequest 事件
     */
    beforeUpload(fileInfo) {
      this.fileList = [fileInfo]
      console.log(this.fileList)
      return false;
    },
    handleRemove () {
      this.fileList = []
      this.uploading = false
    },
    /** 下载模板操作 */
    importTemplate () {
      this.download('user/brokerage-head/importTemplate', {
        ...this.form
      }, `brokerage_template_${new Date().getTime()}.xlsx`)
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.fileList = []
      this.form = {
        id: null,
        name: null,
        fileUrl: null,
        sendNum: null,
        status: 0,
        cateName: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getBrokerage({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          debugger
          this.submitLoading = true
          const { fileList } = this
          const formData = new FormData()
          formData.append('file', fileList[0])
          formData.append('name', this.form.name)
          formData.append('remark', this.form.remark)
          if (this.form.id !== undefined && this.form.id !== null) {
            formData.append('id', this.form.id)
            updateBrokerage(formData).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addBrokerage(formData).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
